import { useEffect, useState } from "react"
import Loader from "../components-legacy/Loader.jsx"
import { api } from "../system/api.js"
import { checkoutSession } from "../system/checkoutSession.js"
import SubscribeCheckout from "./SubscribeCheckout.jsx"

export default function Subscribe() {
    const [checkout, setCheckout] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        const pid = checkoutSession.getPid()

        api('subscribe/initiate', { pid }).then(res => {
            if (res.status === 'success') {
                checkoutSession.removePid()
                window.location.href = '/'
            } else if (res.status === 'checkout') {
                setCheckout(res.checkout)
                checkoutSession.saveCurrency(res.checkout.product.currency)
            } else {
                setError('Unexpected response from server.')
            }
        }).catch(() => {
            setError('Failed to initiate subscription.')
        })
    }, [])

    if (error) {
        return (
            <div className="fixed inset-0 flex items-center justify-center px-4">
                <p className="text-red-600 text-center">{error}</p>
            </div>
        )
    }

    if (checkout) {
        return <SubscribeCheckout pid={checkout.product.pid} checkout={checkout} />
    }

    return <Loader />
}
